import React from 'react';

import TooltipStep from '../TooltipStep';

interface SettingsProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const Settings = (props: SettingsProps) => (
  <TooltipStep
    {...props}
    title="Settings"
    description="Complete your profile and update account settings for a more personalized experience."
  />
);

export default Settings;
